<template>
  <span class="u-user-message">
    <Badge :count="1000" :overflow-count="overflowCount">
      <Icon type="md-notifications-outline" size="24" />
    </Badge>
  </span>
</template>

<script>
// import "@/styles/component/user.less";
export default {
  name: "message",
  data() {
    return {
      overflowCount: 999
    };
  }
};
</script>
